/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import axios from "axios";
import InputField from "components/fields/InputField";
import { Select, Button } from "@chakra-ui/react";

const ReceiverDetailTab: React.FC<{
  detail: any;
  setSwalProps: any;
  countries: any;
  dialcodeList: any;
  userPermissions: any;
}> = ({ detail, setSwalProps, countries, dialcodeList, userPermissions }) => {
  const [receiverDetailForEdit, setReceiverDetailForEdit] = useState(null);
  const [isUpdating, setIsUpdating] = useState<boolean>(false);
  const userRole = localStorage.getItem("userRole")?.toLowerCase();
  const username = localStorage.getItem("username");

  useEffect(() => {
    setReceiverDetailForEdit(detail);
  }, [detail]);

  const handleInputChange = async (event: any) => {
    const { id, value } = event.target;
    if (id === "phone") {
      const numericValue = value.replace(/[^0-9]/g, "");
      setReceiverDetailForEdit({ ...receiverDetailForEdit, [id]: numericValue });
    } else {
      setReceiverDetailForEdit({ ...receiverDetailForEdit, [id]: value });
    }
  };

  const isValidEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const isFormValid =
    receiverDetailForEdit !== null
      ? receiverDetailForEdit.first_name &&
        receiverDetailForEdit.last_name &&
        receiverDetailForEdit.email &&
        isValidEmail(receiverDetailForEdit.email) &&
        receiverDetailForEdit.dob &&
        receiverDetailForEdit.dialcode &&
        receiverDetailForEdit.phone &&
        receiverDetailForEdit.address &&
        receiverDetailForEdit.city &&
        receiverDetailForEdit.state &&
        receiverDetailForEdit.postcode &&
        receiverDetailForEdit.country
      : false;
  const handleSubmit = async () => {
    if (isFormValid) {
      let receiverDetailData = JSON.parse(
        JSON.stringify(receiverDetailForEdit)
      );

      delete receiverDetailData["id"];
      delete receiverDetailData["account"];
      delete receiverDetailData["created_at"];
      delete receiverDetailData["kyc_status"];
      delete receiverDetailData["status"];
      delete receiverDetailData["applicant_id"];

      receiverDetailData.userRole = userRole;
      receiverDetailData.username = username;
      receiverDetailData.updateid = receiverDetailForEdit.id;

      try {
        setIsUpdating(true);
        await axios
          .post(
            process.env.REACT_APP_API_URL +
              `/api/${userRole}/receiver/action/update-receiver`,
            receiverDetailData
          )
          .then(function (response) {
            if (response && response.data?.status === "ok") {
              setSwalProps({
                show: true,
                icon: "success",
                title: "Success",
                html: "Receiver has been successfully updated",
                showConfirmButton: true,
                didClose: () => {
                  setSwalProps({});
                  setIsUpdating(false);
                },
              });
            } else {
              setIsUpdating(false);
              setSwalProps({
                show: true,
                icon: "error",
                title: "Oops!",
                html: response.data.message,
                showConfirmButton: true,
                didClose: () => {
                  setSwalProps({});
                  setIsUpdating(false);
                },
              });
            }
          })
          .catch(function (error) {
            setIsUpdating(false);
            setSwalProps({
              show: true,
              icon: "error",
              title: "Oops!",
              html: error.response.data.message,
              showConfirmButton: true,
              didClose: () => {
                setSwalProps({});
                setIsUpdating(false);
              },
            });
          });
      } catch (error) {
        setIsUpdating(false);
        setSwalProps({
          show: true,
          icon: "error",
          title: "Oops!",
          html: "Something went wrong, please try again later.",
          showConfirmButton: true,
          didClose: () => {
            setSwalProps({});
            setIsUpdating(false);
          },
        });
      }
    }
  };

  const preventTyping = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // Allow Ctrl/Command + C (Copy)
    if ((e.ctrlKey || e.metaKey) && e.key === "c") {
      return; // Allow copy
    }

    // Prevent all other key presses
    e.preventDefault();
  };

  return (
    <>
      {receiverDetailForEdit !== null &&
      countries !== null &&
      dialcodeList !== null ? (
        <>
          {!userPermissions?.editReceiver && (
            <>
              <div className="flex flex-wrap justify-between">
                <div className="w-full space-y-6 text-sm text-navy-700 dark:text-gray-300 md:w-1/2 md:pr-4">
                  <div className="space-y-1">
                    <label>First Name</label>
                    <p className="font-semibold">
                      {receiverDetailForEdit.first_name}
                    </p>
                  </div>
                  <div className="space-y-1">
                    <label>Middle Name</label>
                    <p className="font-semibold">
                      {receiverDetailForEdit.middle_name !== ""
                        ? receiverDetailForEdit.middle_name
                        : "-"}
                    </p>
                  </div>

                  <div className="space-y-1">
                    <label>Last Name</label>
                    <p className="font-semibold">
                      {receiverDetailForEdit.last_name}
                    </p>
                  </div>

                  <div className="space-y-1">
                    <label>Gender</label>
                    <p className="font-semibold">
                      {receiverDetailForEdit.gender !== "" &&
                      receiverDetailForEdit.gender
                        ? receiverDetailForEdit.gender === "M"
                          ? "Male"
                          : "Female"
                        : "-"}
                    </p>
                  </div>

                  {userPermissions?.editReceiverEmailOnly && (
                    <div className="space-y-1">
                      <InputField
                        disabled={isUpdating}
                        variant=""
                        extra="shadow-sm w-[60%]"
                        label="Email"
                        required={true}   
                        placeholder=""
                        id="email"
                        type="email"
                        autoComplete="off"
                        value={receiverDetailForEdit.email}
                        onChange={handleInputChange}
                      />
                    </div>
                  )}

                  {!userPermissions?.editReceiverEmailOnly && (
                    <>
                      <div className="space-y-1">
                        <label>Email</label>
                        <p className="font-semibold">
                          {receiverDetailForEdit.email}
                        </p>
                      </div>
                    </>
                  )}

                  <div className="space-y-1">
                    <label>Date of Birth</label>
                    <p className="font-semibold">{receiverDetailForEdit.dob}</p>
                  </div>

                  <div className="space-y-1">
                    <label>Dial Code</label>
                    <p className="font-semibold">
                      {receiverDetailForEdit.dialcode}
                    </p>
                  </div>
                  <div className="space-y-1">
                    <label>Phone</label>
                    <p className="font-semibold">
                      {receiverDetailForEdit.phone}
                    </p>
                  </div>
                </div>

                <div className="w-full space-y-6 text-sm text-navy-700 dark:text-gray-300 md:w-1/2 md:pr-4">
                  <div className="space-y-1">
                    <label>Address</label>
                    <p className="font-semibold">
                      {receiverDetailForEdit.address}
                    </p>
                  </div>

                  <div className="space-y-1">
                    <label>Address 2</label>
                    <p className="font-semibold">
                      {receiverDetailForEdit.address2 &&
                      receiverDetailForEdit.address2 !== ""
                        ? receiverDetailForEdit.address2
                        : "-"}
                    </p>
                  </div>

                  <div className="space-y-1">
                    <label>City</label>
                    <p className="font-semibold">
                      {receiverDetailForEdit.city}
                    </p>
                  </div>
                  <div className="space-y-1">
                    <label>State</label>
                    <p className="font-semibold">
                      {receiverDetailForEdit.state &&
                      receiverDetailForEdit.state !== ""
                        ? receiverDetailForEdit.state
                        : "-"}
                    </p>
                  </div>
                  <div className="space-y-1">
                    <label>Postcode</label>
                    <p className="font-semibold">
                      {receiverDetailForEdit.postcode}
                    </p>
                  </div>
                  <div className="space-y-1">
                    <label>Country</label>
                    <p className="font-semibold">
                      {receiverDetailForEdit.country}
                    </p>
                  </div>

                  <div className="space-y-1">
                    <label>Reference</label>
                    <p className="font-semibold">
                      {receiverDetailForEdit.reference &&
                      receiverDetailForEdit.reference !== ""
                        ? receiverDetailForEdit.reference
                        : "-"}
                    </p>
                  </div>

                  <div className="space-y-1">
                    <a
                      rel="noreferrer"
                      href={`https://cockpit.sumsub.com/checkus#/applicant/${receiverDetailForEdit.applicant_id}`}
                      target="_blank"
                      className="mb-1 text-sm text-navy-600 underline hover:text-primary-700 dark:text-white"
                    >
                      Applicant ID
                    </a>
                    <p className="font-semibold">
                      {receiverDetailForEdit.applicant_id}
                    </p>
                  </div>
                </div>
              </div>

              {userPermissions?.editReceiverEmailOnly && (
                <div className="flex flex-wrap justify-end">
                  <Button
                    onClick={() => handleSubmit()}
                    isDisabled={!isFormValid || isUpdating}
                    isLoading={isUpdating}
                    loadingText="Updating Receiver..."
                    className="btn-primary relative overflow-hidden rounded-md px-8 py-2.5 font-semibold text-white shadow-md transition-colors duration-300 hover:bg-primary-500 active:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60"
                  >
                    <span className="relative z-10 tracking-tight">
                      Update Receiver
                    </span>
                    <span className="absolute inset-0 z-0 scale-0 rounded-md bg-white/20 opacity-0 transition-all duration-500 group-hover:scale-150 group-hover:opacity-100" />
                  </Button>
                </div>
              )}
            </>
          )}
          {userPermissions?.editReceiver && (
            <>
              <div className="flex flex-wrap justify-between">
                <div className="w-full md:w-1/2 md:pr-4">
                  <InputField
                    disabled={isUpdating}
                    variant="auth"
                    extra="mb-4 shadow-sm"
                    label="First Name"
                    required={true}
                    placeholder=""
                    id="first_name"
                    type="text"
                    autoComplete="off"
                    value={receiverDetailForEdit.first_name}
                    onChange={handleInputChange}
                  />

                  <InputField
                    disabled={isUpdating}
                    variant="auth"
                    extra="mb-4 shadow-sm"
                    label="Middle Name"
                    placeholder=""
                    id="middle_name"
                    type="text"
                    autoComplete="off"
                    value={receiverDetailForEdit.middle_name}
                    onChange={handleInputChange}
                  />

                  <InputField
                    disabled={isUpdating}
                    variant="auth"
                    extra="mb-4 shadow-sm"
                    label="Last Name"
                    required={true}
                    placeholder=""
                    id="last_name"
                    type="text"
                    autoComplete="off"
                    value={receiverDetailForEdit.last_name}
                    onChange={handleInputChange}
                  />

                  <label className="mb-1 text-sm font-medium text-navy-700 dark:text-white">
                    Gender
                  </label>

                  <Select
                    disabled={isUpdating}
                    id="gender"
                    value={receiverDetailForEdit.gender}
                    onChange={handleInputChange}
                    className="custom-select relative mb-4 h-10 w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:outline-none sm:text-sm"
                  >
                    <option value="">-- Please Select --</option>
                    <option value="M">Male</option>
                    <option value="F">Female</option>
                  </Select>

                  <InputField
                    disabled={isUpdating}
                    variant="auth"
                    extra="mb-4 shadow-sm"
                    label="Email"
                    required={true}
                    placeholder=""
                    id="email"
                    type="email"
                    autoComplete="off"
                    value={receiverDetailForEdit.email}
                    onChange={handleInputChange}
                  />
                  <InputField
                    disabled={isUpdating}
                    variant="auth"
                    extra="mb-4 shadow-sm h-[42px]"
                    label="Date of Birth"
                    required={true}
                    placeholder=""
                    id="dob"
                    type="date"
                    autoComplete="off"
                    value={receiverDetailForEdit.dob}
                    onChange={handleInputChange}
                  />

                  <label className="mb-1 text-sm font-medium text-navy-700 dark:text-white">
                    Dialcode <span className="text-red-500">*</span>
                  </label>

                  <Select
                    disabled={isUpdating}
                    id="dialcode"
                    value={receiverDetailForEdit.dialcode}
                    onChange={handleInputChange}
                    className="custom-select relative mb-4 h-10 w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:outline-none sm:text-sm"
                  >
                    <option value="">-- Please Select --</option>
                    {Object.entries(dialcodeList).map(
                      ([key, value]: [any, any]) => (
                        <option key={key} value={key}>
                          {value}
                        </option>
                      )
                    )}
                  </Select>

                  <InputField
                    disabled={isUpdating}
                    variant="auth"
                    extra="mb-4 shadow-sm"
                    label="Phone"
                    required={true}
                    placeholder=""
                    id="phone"
                    type="text"
                    autoComplete="off"
                    value={receiverDetailForEdit.phone}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="w-full md:w-1/2 md:pl-4">
                  <InputField
                    disabled={isUpdating}
                    variant="auth"
                    extra="mb-4 shadow-sm"
                    label="Address"
                    required={true}
                    placeholder=""
                    id="address"
                    type="text"
                    autoComplete="off"
                    value={receiverDetailForEdit.address}
                    onChange={handleInputChange}
                  />

                  <InputField
                    disabled={isUpdating}
                    variant="auth"
                    extra="mb-4 shadow-sm"
                    label="Address 2"
                    placeholder=""
                    id="address2"
                    type="text"
                    autoComplete="off"
                    value={receiverDetailForEdit.address2}
                    onChange={handleInputChange}
                  />

                  <InputField
                    disabled={isUpdating}
                    variant="auth"
                    extra="mb-4 shadow-sm"
                    label="City"
                    required={true}
                    placeholder=""
                    id="city"
                    type="text"
                    autoComplete="off"
                    value={receiverDetailForEdit.city}
                    onChange={handleInputChange}
                  />

                  <InputField
                    disabled={isUpdating}
                    variant="auth"
                    extra="mb-4 shadow-sm"
                    label="State"
                    placeholder=""
                    id="state"
                    type="text"
                    autoComplete="off"
                    value={receiverDetailForEdit.state}
                    onChange={handleInputChange}
                  />

                  <InputField
                    disabled={isUpdating}
                    variant="auth"
                    extra="mb-4 shadow-sm"
                    label="Postcode"
                    required={true}
                    placeholder=""
                    id="postcode"
                    type="text"
                    autoComplete="off"
                    value={receiverDetailForEdit.postcode}
                    onChange={handleInputChange}
                  />

                  <label className="text-sm font-medium text-navy-700 dark:text-white">
                    Country <span className="text-red-500">*</span>
                  </label>

                  <Select
                    disabled={isUpdating}
                    id="country"
                    value={receiverDetailForEdit.country}
                    onChange={handleInputChange}
                    className="custom-select relative mb-4 h-10 w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:outline-none sm:text-sm"
                  >
                    <option value="">-- Please Select --</option>
                    {countries.map((item: any) => (
                      <option key={item.id} value={item.country_code_3}>
                        {item.country_name}
                      </option>
                    ))}
                  </Select>

                  <InputField
                    disabled={isUpdating}
                    variant="auth"
                    extra="mb-4 shadow-sm"
                    label="Reference"
                    placeholder=""
                    id="reference"
                    type="text"
                    autoComplete="off"
                    value={receiverDetailForEdit.reference}
                    onChange={handleInputChange}
                  />

                  {receiverDetailForEdit.applicant_id && (
                    <InputField
                      variant="auth"
                      extra="mb-4 shadow-sm"
                      label="Sumsub Applicant ID"
                      labelAsLink={`https://cockpit.sumsub.com/checkus#/applicant/${receiverDetailForEdit.applicant_id}`}
                      placeholder=""
                      id="sumsub_link"
                      type="text"
                      autoComplete="off"
                      value={receiverDetailForEdit.applicant_id}
                      onChange={handleInputChange}
                      onKeyDown={preventTyping}
                    />
                  )}
                </div>
              </div>
              <div className="flex flex-wrap justify-end">
                <Button
                  onClick={() => handleSubmit()}
                  isDisabled={!isFormValid || isUpdating}
                  isLoading={isUpdating}
                  loadingText="Updating Receiver..."
                  className="btn-primary relative overflow-hidden rounded-md px-8 py-2.5 font-semibold text-white shadow-md transition-colors duration-300 hover:bg-primary-500 active:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60"
                >
                  <span className="relative z-10 tracking-tight">
                    Update Receiver
                  </span>
                  <span className="absolute inset-0 z-0 scale-0 rounded-md bg-white/20 opacity-0 transition-all duration-500 group-hover:scale-150 group-hover:opacity-100" />
                </Button>
              </div>
            </>
          )}
        </>
      ) : (
        <div>
          <div
            className="mb-3 h-5 animate-pulse rounded-md bg-gray-200"
            style={{ animationDuration: "0.6s" }}
          ></div>
          <div
            className="mb-3 h-5 animate-pulse rounded-md bg-gray-200"
            style={{ animationDuration: "0.6s" }}
          ></div>
          <div
            className="mb-3 h-5 animate-pulse rounded-md bg-gray-200"
            style={{ animationDuration: "0.6s" }}
          ></div>
          <div
            className="mb-3 h-5 animate-pulse rounded-md bg-gray-200"
            style={{ animationDuration: "0.6s" }}
          ></div>
        </div>
      )}
    </>
  );
};

export default ReceiverDetailTab;
